import {ROLE_ADMIN_CENTER, ROLE_PATIENT, ROLE_PROFESSIONAL, ROLE_SUPER_ADMIN} from './roles';

/**
 * Class to manage the configurations in the control of access to components via URL
 *
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export class AccessControl {
  public static onInvalidTokenMessage = 'Lo sentimos, su sesión ha expirado intente acceder nuevamente a la plataforma, si el error persiste ' +
    'puede ponerse en contacto con los administradores.'
  public static onAuthenticationFailureMessage = 'Credenciales inválidas'
  /**
   * Allows you to configure the route and URL to redirect to if access is denied.
   * The path property specifies the route path, while the url property specifies the full URL to redirect to.
   */
  public static REDIRECT_ON_ACCESS_DENIED_ROUTE: { path: string, url: string } = {
    path: 'dashboard',
    url: '/dashboard',
  };
  /**
   * It allows to determine if the authenticated user in case of not having any value can access or not, by default it is false.
   */
  public static GRANT_ACCESS_IF_USER_HAS_NO_ROLE = false;
  /**
   * Enable or disable access control
   */
  public static CHECK_ACCESS = true;
  /**
   * It allows us to deny access based on the specific role or permission the user has.
   */
  public static DENY_LOGIN_ACCESS_BY_ROLE: string[] = [ROLE_PATIENT.value];

  /**
   * Method to get the access list according to the invoked route
   * @author Carlos Duardo <carlos.duardo@qualud.com>
   */
  public static getAccessControlListByRole(): { [key: string]: string[] } {
    let accessControlByRole: Record<string, string[]> = {};


    const COMMON_ROUTES: string[] = [
      //here you can define al common routes regarles the value
      'profile',
    ];

    //you can create more access controls for each value of your business in the same way of  ROLE_ADMIN & ROLE_PATIENT
    accessControlByRole[ROLE_SUPER_ADMIN.value] = [
      ...COMMON_ROUTES,
      // 'group',
      'center',
      'professional',
      'user',
      'patient',
      'administrator-center'
    ];
    accessControlByRole[ROLE_PROFESSIONAL.value] = [
      ...COMMON_ROUTES,
      'patient',
    ];
    accessControlByRole[ROLE_ADMIN_CENTER.value] = [
      ...COMMON_ROUTES,
      'professional',
      'patient',
    ];

    return accessControlByRole;
  }



}
